export default Object.freeze({
    news: 1,
    workshop: 2,
    event: 4
  });